import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Assistant from "@/pages/Assistant";
import Store from "@/pages/Store";
import Pricing from "@/pages/Pricing";
import Startup from "@/pages/Startup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import SignPolicy from "@/pages/SignPolicy";
import SignBundle from "@/pages/SignBundle";
import Dashboard from "@/pages/Dashboard";
import MyPolicies from "@/pages/MyPolicies";
import PolicyEditor from "@/pages/PolicyEditor";
import SignoffMatrix from "@/pages/SignoffMatrix";
import RegulatoryUpdates from "@/pages/RegulatoryUpdates";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import MockInterview from "@/pages/MockInterview";
import Team from "@/pages/Team";
import JoinTeam from "@/pages/JoinTeam";
import Evidence from "@/pages/Evidence";
import Training from "@/pages/Training";
import Inspections from "@/pages/Inspections";
import Advertise from "@/pages/Advertise";
import Blog from "@/pages/Blog";
import Article from "@/pages/Article";
import Billing from "@/pages/Billing";
import Sector from "@/pages/Sector";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cookies from "@/pages/Cookies";
import Suppliers from "@/pages/Suppliers";
import Partner from "@/pages/Partner";
import InspectionDay from "@/pages/InspectionDay";
import Unsubscribe from "@/pages/Unsubscribe";
import Tour from "@/pages/Tour";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/resources" element={<Store />} />
            <Route path="/guidance" element={<Blog />} />
            <Route path="/guidance/:slug" element={<Article />} />
            <Route path="/cqc" element={<Sector sectorId="cqc" />} />
            <Route path="/ofsted" element={<Sector sectorId="ofsted" />} />
            <Route path="/aesthetics" element={<Sector sectorId="aesthetics" />} />
            <Route path="/gp-hospitals" element={<Sector sectorId="healthcare" />} />
            <Route path="/fostering" element={<Sector sectorId="fostering" />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/start-up" element={<Startup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/sign/:token" element={<SignPolicy />} />
            <Route path="/sign-all/:token" element={<SignBundle />} />
            <Route path="/updates" element={<RegulatoryUpdates />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/assistant" element={<Assistant />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/partner" element={<Partner />} />
            <Route path="/inspection-day" element={<ProtectedRoute><InspectionDay /></ProtectedRoute>} />
            <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
            <Route path="/tour" element={<Tour />} />
            <Route path="/join-team" element={<JoinTeam />} />
            <Route path="/advertise" element={<Advertise />} />
            <Route path="/evidence" element={<ProtectedRoute><Evidence /></ProtectedRoute>} />
            <Route path="/training" element={<ProtectedRoute><Training /></ProtectedRoute>} />
            <Route path="/inspections" element={<ProtectedRoute><Inspections /></ProtectedRoute>} />
            <Route
              path="/team"
              element={<ProtectedRoute><Team /></ProtectedRoute>}
            />
            <Route
              path="/mock-interview"
              element={<ProtectedRoute><MockInterview /></ProtectedRoute>}
            />
            <Route
              path="/dashboard"
              element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
            />
            <Route
              path="/policies"
              element={<ProtectedRoute><MyPolicies /></ProtectedRoute>}
            />
            <Route
              path="/policies/signoffs"
              element={<ProtectedRoute><SignoffMatrix /></ProtectedRoute>}
            />
            <Route
              path="/policies/:sector/:title"
              element={<ProtectedRoute><PolicyEditor /></ProtectedRoute>}
            />
            <Route
              path="/billing"
              element={<ProtectedRoute><Billing /></ProtectedRoute>}
            />
            <Route
              path="/admin"
              element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
